import { Button } from "primereact/button";
import React, { useState } from "react";
import PageHeader from "./PageHeader";

const Dashboard: React.FC = () => {
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = () => {
    setRefreshing(true);
    // Add your refresh logic here
    setTimeout(() => {
      setRefreshing(false);
      // You can add success notification here if needed
    }, 1000);
  };

  return (
    <div className="content">
      <PageHeader
        title="Dashboard"
        beforeTitle={
          <Button
            icon={`pi pi-refresh ${refreshing ? "pi-spin" : ""}`}
            rounded
            text
            severity="secondary"
            onClick={handleRefresh}
            disabled={refreshing}
            tooltip="Refresh"
            tooltipOptions={{ position: "bottom" }}
            aria-label="Refresh Dashboard"
          />
        }
      />
      <div className="content-body">
        <div className="container mt-4">
          <h2>Dashboard</h2>
          <p>Welcome to your dashboard!</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
